import gql from "graphql-tag";

export const notificationEmailsAndApplicationSettingsQuery = gql`
  query notificationEmails($group: NotificationEmailGroup!) {
    notificationEmails(group: $group) {
      id
      email
    }
    customerApplicationSettings {
      managerProcessingNormHours
      managerProcessingNormMinutes
    }
  }
`;
